import styled from 'styled-components';
import {dFlex, dFlexCenter, dFlexColumn, alignCenter, justifyStart} from '../../../../globalVariables/GlobalFlex';
import {maskImage,GRAY3,BGImageCenter,LIGHT_BLUE4,mobileMedia} from '../../../../globalVariables/GlobalVariables';
import {whatsApp, bubble, mail} from '../../../../assets/symbols/symbols/Symbols.css';

export const sendingImage = 'https://static.tickchak.co.il/images/app/mailing/sendingImage.png';

export const tabsContainer = styled.div`
    background-color: ${LIGHT_BLUE4};
    ${dFlex};
    ${justifyStart};
    height: 60px;
    transition: all 400ms;
    &::after {
        content: '';
        ${BGImageCenter(sendingImage,'contain')}
        position: absolute;
        top: 10px;
        inset-inline-end: 20px;
        width: 160px;
        height: 134px;
        ${mobileMedia} {
            width: 130px;
            height: 107px;
            inset-inline-end: 0px;
        }
    }
`;

export const tabsMenu = styled.div`
    ${dFlex};
    ${alignCenter};
    gap: 40px;
    position: relative;
    height: 100%;
    padding-inline: 60px;
    ${mobileMedia} {
        padding-inline: 20px;
    }
`;

export const tabItem = styled.button`
    ${dFlexColumn};
    ${alignCenter};
    ${dFlexCenter};
    cursor: pointer;
    height: 100%;
    transition: all 0.3s ease;
    background: none;
    border: none;
    padding: 0;
    &:disabled {
        pointer-events: none;
        opacity: 0.5;
    }
    &.current {
        border-bottom: 3px solid ${GRAY3};
    }
`;

export const tabIcon = styled.div`
    width: 16px;
    height: 16px;
    ${dFlexCenter};
    color: ${GRAY3};
    font-size: 20px;
    
    &.whatsapp {
        ${maskImage(whatsApp, GRAY3, 'contain')}
    }
    
    &.sms {
        ${maskImage(bubble, GRAY3, 'contain')}
    }
    
    &.email {
        ${maskImage(mail, GRAY3, 'contain')}
    }
`;

export const tabText = styled.div`
    font-size: 14px;
    color: ${GRAY3};
    font-weight: 500;
    text-align: center;
`;
